import Vue from 'vue'
import axios from 'axios'

const server = window.localServer ? window.localServer : 'http://local.test'

export default class API {
    /**
     * Make request to the given endpoint.
     *
     * @param endpoint
     * @param method
     * @param data
     * @param requestSettings
     * @return {Promise<any>}
     */
    static async request(endpoint, method, data, requestSettings) {
        if (typeof requestSettings === 'undefined') {
            requestSettings = {};
        }

        let settings = {
            method: method,
            url: (requestSettings.server ? requestSettings.server : server) + endpoint
        }

        if (settings.method === 'GET') {
            settings['params'] = data || {}
        } else {
            settings['data'] = data || {}
        }

        if (requestSettings) {
            settings = Object.assign(settings, requestSettings)
        }

        settings.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'locale': localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en'
        }

        let callback = async (token) => {
            if (token) {
                settings.headers['Authorization'] = `Bearer ${token}`
            }

            try {
                let {data} = await axios(settings)
                return data
            } catch (e) {
                if (e && e.response && e.response.status === 401) {
                    window.location.reload()
                }

                throw e
            }
        }

        return callback()
    }

    static storeTranslations(payload) {
        return API.request('/api/translations/store', 'POST', payload)
    }

    static switchTranslations(locale) {
        return API.request('/api/translations/switch', 'POST', {
            locale: locale
        })
    }

    static getPages() {
        return API.request('/api/pages', 'GET');
    }

    static subscribe(email) {
        let payload = {
            email: email,
            source: window.location.origin
        }

        return API.request('/api/subscribe', 'POST', payload)
    }
}
